import { useMedia } from 'react-media';
import { DOCUMENT_COLLAPSED_LAYOUT_SIZE } from '@app/components/document-layout-container/helpers';

export const useDocumentLayoutMode = () => {
  // Chose 320px because issues with the collapsed layout starts.
  const isSmallHeight = useMedia({
    query: '(max-height: 320px)',
  });
  const isSmallWidth = useMedia({
    query: `(max-width: ${DOCUMENT_COLLAPSED_LAYOUT_SIZE}px)`,
  });

  const isCollapsedLayout = isSmallHeight || isSmallWidth;
  const isExpandedLayout = !isCollapsedLayout;

  return {
    isExpandedLayout,
    isCollapsedLayout,
  };
};
